import { tv } from '~/utils/tv'

export const SnackbarRootVariants = tv({
  base: `
    flex flex-col min-w-[256px] max-w-[768px] border-quarterpulse
    rounded-form border-border-neutral overflow-hidden
    pb-fourpulse
   `,
  variants: {
    type: {
      'brand-accent': 'bg-fill-neutral',
      informative: 'bg-fill-informative-alternative',
      success: 'bg-fill-success-alternative',
      warning: 'bg-fill-warning-alternative',
      danger: 'bg-fill-danger-alternative',
    },
  },
})
